'use client'
import React, { useState } from "react";
import Link from "next/link";
import StartTrialBtn from "../StartTrialBtnProducts";
import IndustryComponent from "@/component/AboutUs/IndustryComponent";
import PlaceIcon from "@mui/icons-material/Place";
import Image from "next/image";
import OurVisionIco from "@/Helper/images/our_vision.svg";
import OurMissionIco from "@/Helper/images/our_mission.svg";
import LearnLeadExcelIco from "@/Helper/images/learn_lead_excel.svg";
import CollaborateElevateIco from "@/Helper/images/collaborate_elevate.svg";
import ClientCenteredExcellenceIco from "@/Helper/images/client_centered_excellence.svg";
import EmpoweredOwnershipIco from "@/Helper/images/empowered_ownership.svg";
import InnovateWithInsightIco from "@/Helper/images/innovate_withInsight.svg";

export default function Aboutus() {
  return (
    <>
      <section className="banner_bg1 Aboutus_bg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                We Empower Organizations to Thrive with Data-Driven Insights
              </h1>
              <p className="banner_text1">
                Partner with us to unlock the full potential of your data. Let’s turn insights into strategies and
                strategies into success!
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="about_topsect">
        <div className="container">
          <div className="about_topsectinner">
            <div className="common_titbox">
              <h2 className="common_hd">Data is Our Belief
              </h2>
              <p className="common_desc">At iKnot, we hold a steadfast belief that every piece of data carries the potential to transform businesses. Our mission is to empower organizations by converting raw data into actionable insights
                that fuel growth, enhance decision-making, and unlock tangible value. In today’s dynamic data-
                driven world, we serve as a trusted partner, guiding businesses through data strategy, governance,
                analytics, and cloud migration. At iKnot, data is not just information—it’s your competitive
                advantage.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="abt2section">
        <div className="container">
          <div className="abt2inner">
            <div className="abtlist abtlist1">
              <div className="abt-topico">
                <Image
                  src={OurVisionIco}
                  alt="Our Vision"
                />
              </div>
              <h3 className="abt_tit1">Our Vision</h3>
              <p className="abt_desc1">At iKnot, we envision a world where data is the foundation for transformative innovation and meaningful progress. We strive to lead the data revolution by empowering organizations to unlock
                the full potential of their data. Our aim is to enable unparalleled innovation, informed decision-
                making, and a positive societal impact. We aspire to be a trusted catalyst for businesses, driving a
                future where data not only informs but inspires lasting change and advances industries globally.</p>
            </div>
            <div className="abtlist abtlist2">
              <div className="abt-topico">
                <Image
                  src={OurMissionIco}
                  alt="Our Mission"
                /></div>
              <h3 className="abt_tit1">Our Mission</h3>
              <p className="abt_desc1">Our mission is to empower organizations with actionable insights that transform data into a strategic asset. We are dedicated to revolutionizing data analytics through innovation, ethical practices, and a
                relentless focus on delivering impactful solutions. By turning complex data into a force for growth
                and progress, we aim to drive meaningful decisions that shape a better future for businesses and
                society.</p>
            </div>
          </div>
        </div>
      </section>
      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox">
                <h2 className="common_hd">Our Core Values</h2>

                <p className="common_desc">Our Core Values define who we are and guide every decision we make. They represent our commitment to integrity, excellence, and innovation in everything we do. By fostering trust, inclusivity, and respect, we strive to create a positive impact on our community, customers, and team. These values are the foundation of our journey toward growth and success, inspiring us to achieve more together.</p>

              </div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={LearnLeadExcelIco}
                    alt="Learn, Lead, Excel"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Learn, Lead, Excel</h3>
                  <p className="bx_rightdesc">We embrace continuous learning to stay at the forefront of our field. By empowering our team to lead with expertise, we foster an environment where innovation thrives, ensuring excellence in every project and outcome.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={CollaborateElevateIco}
                    alt="Collaborate to Elevate"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Collaborate to Elevate</h3>
                  <p className="bx_rightdesc">Collaboration is key to delivering the best solutions. By combining diverse expertise and perspectives, we tackle challenges together, elevating both our team and our outcomes through shared knowledge and teamwork.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ClientCenteredExcellenceIco}
                    alt="Client-Centered Excellence"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Client-Centered Excellence</h3>
                  <p className="bx_rightdesc">We place our clients’ needs at the forefront, customizing data solutions to meet their specific goals. Our commitment to excellence ensures measurable results that foster long-term relationships built on trust and respect.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={EmpoweredOwnershipIco}
                    alt="Empowered Ownership"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Empowered Ownership</h3>
                  <p className="bx_rightdesc">Empowered Ownership encourages individuals to take initiative, make decisions, and lead their projects with confidence, promoting a sense of responsibility and self-direction within a collaborative culture.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InnovateWithInsightIco}
                    alt="Innovate with Insight"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Innovate with Insight</h3>
                  <p className="bx_rightdesc">Innovation drives our approach to data analytics, transforming raw data into forward- thinking solutions. We push boundaries to create impactful insights that solve challenges and inspire new opportunities for our clients.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="abt_citysection">
        <div className="container">
          <div class="common_titbox common_titboxcenter"><h2 class="common_hd">Our Location</h2>
            <p className="common_desc">iKnot offers local expertise with a global perspective.</p></div>
          <div className="abt_cityinner">
          <div className="card_abtcty">
              <div className="abtctyicon">
                <PlaceIcon />
              </div>
              <div className="abtctyright">
                <h3>Vienna, Austria</h3>
                <p> Europaplatz, Westbahnhof,</p>
                <p>Vienna, 1150 </p>
                <p><strong> Mobile: </strong><Link href="tel:+436641430563"> (+43) 664 1430563 </Link> </p>
                <p><strong> Email: </strong><Link href="mailto:info@iknotanalytics.com"> info@iknotanalytics.com </Link></p>
              </div>
            </div>
            <div className="card_abtcty">
              <div className="abtctyicon">
                <PlaceIcon />
              </div>
              <div className="abtctyright">
                <h3>Bengaluru , India</h3>
                <p> Shyam Mohan, Yelachenahalli,</p>
                <p> Karnataka-560078, India</p>
                <p><strong>Mobile: </strong> <Link href="tel:+919488548833"> (+91) 9488 54 8833 </Link> </p>
                <p><strong>Email: </strong><Link href="mailto:sales@iknotanalytics.com"> sales@iknotanalytics.com </Link></p>
              </div>
            </div>
            <div className="card_abtcty">
              <div className="abtctyicon">
                <PlaceIcon />
              </div>
              <div className="abtctyright">
                <h3>Dharmapuri , India</h3>
                <p>4/50, Mariamman Kovil Street,</p>
                <p>Hale Dharmapuri, Tamil Nadu-636701</p>
                <p><strong>Mobile: </strong> <Link href="tel:+919488548833"> (+91) 9488 54 8833 </Link> </p>
                <p><strong>Email: </strong><Link href="mailto:sales@iknotanalytics.com"> sales@iknotanalytics.com </Link></p>
              </div>
            </div>
          
          </div>
        </div>
      </section>
    </>
  );
}